'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { AlertTriangle } from 'lucide-react';
import { Button as DsButton } from '@/components/ds';

export default function ProfileError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[/u/[username]] route error:', error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-0 px-4">
      <div className="max-w-md text-center">
        <div className="w-14 h-14 rounded-full bg-surface-2 border border-border-subtle flex items-center justify-center mx-auto mb-4">
          <AlertTriangle className="w-7 h-7 text-status-busy" strokeWidth={1.75} />
        </div>
        <h2 className="text-text-primary text-lg font-semibold mb-2">Couldn’t load this profile</h2>
        <p className="text-text-secondary text-sm mb-6">
          Something went wrong while loading the profile. This is usually temporary.
        </p>
        <div className="flex gap-2 justify-center">
          <DsButton variant="primary" size="md" onClick={() => reset()}>
            Try again
          </DsButton>
          <Link
            href="/home"
            className="inline-flex items-center h-8 px-3.5 rounded-sm text-sm font-medium bg-surface-3 text-text-primary border border-border-default hover:bg-surface-2"
          >
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}
